import React from 'react';

const TwitterIcon = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            className={className}
        >
            <rect width='18' height='18' rx='9' fill='black' />
            <path
                d='M12.1631 3.95215H13.8499L10.1649 8.16389L14.5 13.8951H11.1056L8.44702 10.4192L5.40497 13.8951H3.71722L7.65872 9.3902L3.5 3.95215H6.98055L9.3837 7.12931L12.1631 3.95215ZM11.5712 12.8855H12.5058L6.4727 4.90871H5.46973L11.5712 12.8855Z'
                fill='white'
            />
        </svg>
    );
};

export { TwitterIcon };
